(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(3795);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2739);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);








var SlickPartner = function(param) {
    var dataPartner = param.dataPartner;
    var settings = {
        infinite: true,
        slidesToShow: 9,
        slidesToScroll: 1,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 2000,
        cssEase: "linear",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    initialSlide: 2,
                    dots: true
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    dots: true
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "row text-black",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "col-md-12",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-center",
                            children: "PARTNER"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-center",
                            children: "Kami bekerjasama dengan beberapa instansi lain"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "col-md-12",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, settings), {
                            children: dataPartner.map(function(p, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                                        src: "".concat(p.pictureRelasi),
                                        width: "175",
                                        height: "175",
                                        alt: ""
                                    })
                                }, p._id);
                            })
                        }))
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SlickPartner);


/***/ }),

/***/ 3795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/big/ProductCarousel.jsx
var ProductCarousel = __webpack_require__(3787);
// EXTERNAL MODULE: ./components/big/SlickPartner.jsx
var SlickPartner = __webpack_require__(6555);
// EXTERNAL MODULE: ./components/Layout.jsx + 2 modules
var Layout = __webpack_require__(3987);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/little/Medsos.jsx


var Medsos = function(param) {
    var colorMedsos = param.colorMedsos, fontMedsos = param.fontMedsos, linkMedsos = param.linkMedsos, contentMedsos = param.contentMedsos;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "col-lg-4 col-md-5 col-sm-6 shadow bg-white p-3 rounded mx-1 mb-2 medsos text-black",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-center ",
                style: {
                    color: colorMedsos
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                    className: "bi ".concat(fontMedsos)
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-center fs-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    target: "_blank",
                    href: linkMedsos,
                    rel: "noopener noreferrer",
                    children: contentMedsos
                })
            })
        ]
    });
};
/* harmony default export */ var little_Medsos = (Medsos);

// EXTERNAL MODULE: ./components/big/Carousel.jsx
var Carousel = __webpack_require__(6765);
// EXTERNAL MODULE: ./components/big/CarouselMobile.jsx
var CarouselMobile = __webpack_require__(8433);
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/lib/groupOptions.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function groupOptions(options) {
  const nextOptions = [];
  options.forEach((option, i) => {
    if ('groupId' in option) {
      const nextOption = _extends({}, option);

      const groupIndex = nextOptions.findIndex(el => 'groupId' in el && el.groupId === nextOption.groupId);
      nextOption.index = i;

      if (groupIndex > -1) {
        nextOptions[groupIndex].items.push(nextOption);
      } else {
        nextOptions.push({
          items: [nextOption],
          groupId: option.groupId,
          type: 'group',
          name: option.groupName
        });
      }
    } else {
      nextOptions.push(option);
    }
  });
  return nextOptions;
}
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/lib/valuteToArray.js
function valueToArray(value) {
  if (!value) {
    return [];
  }

  return !Array.isArray(value) ? [value] : [...value];
}
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/lib/isOption.js
function isOption(option) {
  return option !== null && typeof option === 'object' && 'value' in option && 'name' in option;
}
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/lib/getOption.js

function getOption(value, options) {
  if (isOption(value)) {
    return value;
  }

  let newValue = value;

  if (newValue === null && options.length) {
    let i = 0;
    let defaultOption = options[0];

    while (defaultOption && defaultOption.disabled) {
      if (options.length < i) {
        defaultOption = false;
      }

      i += 1;
      defaultOption = options[i];
    }

    if (defaultOption) {
      newValue = defaultOption.value;
    }
  } // eslint-disable-next-line eqeqeq


  return options.find(o => o.value == newValue);
}
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/lib/getOptions.js


function getOptions(value, oldValue, options, multiple) {
  if (!multiple) {
    const newOption = getOption(value, options);

    if (newOption) {
      return newOption;
    }

    return oldValue;
  }

  const oldOptions = valueToArray(oldValue);
  const newOptions = valueToArray(value).map(o => getOption(o, options)).filter(o => o !== null && o !== undefined);

  if (!oldOptions.length) {
    return newOptions;
  }

  if (!newOptions.length) {
    return oldOptions;
  }

  newOptions.forEach(newOption => {
    // eslint-disable-next-line eqeqeq
    const optionIndex = oldOptions.findIndex(o => o.value == newOption.value);

    if (optionIndex >= 0) {
      oldOptions.splice(optionIndex, 1);
    } else {
      oldOptions.push(newOption);
    }
  });
  return oldOptions;
}
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/lib/getDisplayValue.js

function getDisplayValue(value) {
  if (Array.isArray(value)) {
    return value.map(o => isOption(o) && o.name).join(', ');
  }

  return isOption(value) ? value.name : '';
}
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/lib/debounce.js
function debounce(func, wait) {
  let timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = null;
      func(...args);
    }, wait);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/lib/flattenOptions.js
function flattenOptions_extends() { flattenOptions_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return flattenOptions_extends.apply(this, arguments); }

function flattenOptions(options) {
  return options.map((option, i) => {
    if (option.type === 'group') {
      const id = `${option.name.replace(/\s+/g, '-').toLowerCase()}-${i}`;
      return option.items.map(item => flattenOptions_extends({}, item, {
        groupId: id,
        groupName: option.name
      }));
    }

    return flattenOptions_extends({}, option, {
      index: i
    });
  }).flat();
}
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/useFetch.js



function useFetch(q, defaultOptions, _ref) {
  let {
    debounceTime,
    filterOptions,
    getOptions
  } = _ref;
  const [fetching, setFetching] = (0,react.useState)(false);
  const [options, setOptions] = (0,react.useState)(() => flattenOptions(defaultOptions));
  const fetch = (0,react.useMemo)(() => {
    const filter = filterOptions || (op => () => op);

    if (!getOptions) {
      return s => setOptions(flattenOptions(filter(defaultOptions)(s)));
    }

    return debounce(s => {
      const optionsReq = getOptions(s, defaultOptions);
      setFetching(true);
      Promise.resolve(optionsReq).then(newOptions => {
        setOptions(flattenOptions(filter(newOptions)(s)));
      }).finally(() => setFetching(false));
    }, debounceTime);
  }, [filterOptions, defaultOptions, getOptions, debounceTime]);
  (0,react.useEffect)(() => setOptions(defaultOptions), [defaultOptions]);
  (0,react.useEffect)(() => fetch(q), [fetch, q]);
  return {
    options,
    setOptions,
    fetching
  };
}
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/lib/getValue.js

function getValue(option) {
  if (!option) {
    return null;
  }

  return isOption(option) ? option.value : null;
}
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/lib/getValues.js

function getValues(options) {
  if (Array.isArray(options)) {
    return options.map(o => getValue(o)).filter(v => v !== null);
  }

  return getValue(options);
}
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/highlightReducer.js
function highlightReducer(highlighted, _ref) {
  let {
    key,
    options
  } = _ref;
  const max = options.length - 1;
  let newHighlighted = key === 'ArrowDown' ? highlighted + 1 : highlighted - 1;

  if (newHighlighted < 0) {
    newHighlighted = max;
  } else if (newHighlighted > max) {
    newHighlighted = 0;
  }

  const option = options[newHighlighted];

  if (option && option.disabled) {
    return highlightReducer(newHighlighted, {
      key,
      options
    });
  }

  return newHighlighted;
}
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/useHighlight.js


function useHighlight(defaultHighlighted, options, onSelect, ref) {
  const [highlighted, dispatchHighlighted] = (0,react.useReducer)(highlightReducer, defaultHighlighted);
  const onKeyDown = (0,react.useCallback)(e => {
    const {
      key
    } = e;

    if (['ArrowDown', 'ArrowUp'].includes(key)) {
      e.preventDefault();
      dispatchHighlighted({
        key,
        options
      });
    }
  }, [options]);
  const onKeyPress = (0,react.useCallback)(e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const selected = options[highlighted];

      if (selected) {
        onSelect(selected.value);
      }
    }
  }, [options, highlighted, onSelect]);
  const onKeyUp = (0,react.useCallback)(e => {
    if (e.key === 'Escape') {
      e.preventDefault();
      ref.current.blur();
    }
  }, [ref]);
  return [highlighted, {
    onKeyPress,
    onKeyDown,
    onKeyUp
  }];
}
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/useSelect.js
function useSelect_extends() { useSelect_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return useSelect_extends.apply(this, arguments); }








function useSelect(_ref) {
  let {
    value: defaultValue = null,
    options: defaultOptions = [],
    search: canSearch = false,
    multiple = false,
    disabled = false,
    closeOnSelect = true,
    getOptions: getOptionsFn = null,
    filterOptions = null,
    onChange = () => {},
    onFocus = () => {},
    onBlur = () => {},
    debounce = 0
  } = _ref;
  const ref = (0,react.useRef)(null);
  const [value, setValue] = (0,react.useState)(null);
  const [search, setSearch] = (0,react.useState)('');
  const [focus, setFocus] = (0,react.useState)(false);
  const {
    options,
    fetching
  } = useFetch(search, defaultOptions, {
    getOptions: getOptionsFn,
    filterOptions,
    debounceTime: debounce
  });
  const onSelect = (0,react.useCallback)(newValue => {
    const newOption = getOptions(newValue, value, Array.isArray(value) ? [...value, ...options] : options, multiple);
    setValue(newOption);
    onChange(getValues(newOption), newOption);

    if (closeOnSelect) {
      ref.current.blur();
    }
  }, [closeOnSelect, multiple, onChange, value, options]);
  const [highlighted, keyboardEvents] = useHighlight(-1, options, onSelect, ref);
  const snapshot = (0,react.useMemo)(() => ({
    options: groupOptions(options),
    option: value,
    displayValue: getDisplayValue(value),
    value: getValues(value),
    search,
    fetching,
    focus,
    highlighted,
    disabled
  }), [disabled, fetching, focus, highlighted, search, value, options]);
  const onMouseDown = (0,react.useCallback)(e => {
    e.preventDefault();
    onSelect(e.currentTarget.value);
  }, [onSelect]);
  const onFocusCb = (0,react.useCallback)(e => {
    setFocus(true);
    onFocus(e);
  }, [onFocus]);
  const onBlurCb = (0,react.useCallback)(e => {
    setFocus(false);
    setSearch('');
    onBlur(e);
  }, [onBlur]);
  const valueProps = (0,react.useMemo)(() => useSelect_extends({
    tabIndex: '0',
    readOnly: !canSearch
  }, keyboardEvents, {
    onFocus: onFocusCb,
    onBlur: onBlurCb,
    onChange: canSearch ? _ref2 => {
      let {
        target
      } = _ref2;
      return setSearch(target.value);
    } : null,
    disabled,
    ref
  }), [canSearch, keyboardEvents, onFocusCb, onBlurCb, disabled]);
  const optionProps = (0,react.useMemo)(() => ({
    tabIndex: '-1',
    onMouseDown
  }), [onMouseDown]);
  (0,react.useEffect)(() => {
    setValue(getOptions(defaultValue, null, options, multiple));
  }, [defaultValue, multiple, options]);
  return [snapshot, valueProps, optionProps, setValue];
}
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/lib/classes.js
function classes(classNames) {
  return Object.entries(classNames).filter(_ref => {
    let [cls, display] = _ref;
    return cls && display;
  }).map(_ref2 => {
    let [cls] = _ref2;
    return cls;
  }).join(' ');
}
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/Components/Option.js
function Option_extends() { Option_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Option_extends.apply(this, arguments); }







function Option(_ref) {
  let {
    optionProps,
    highlighted,
    selected,
    option,
    cls,
    renderOption
  } = _ref;

  const props = Option_extends({}, optionProps, {
    value: option.value,
    disabled: option.disabled
  });

  const className = classes({
    [cls('option')]: true,
    [cls('is-selected')]: selected,
    [cls('is-highlighted')]: highlighted
  });
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
    className: cls('row'),
    role: "menuitem",
    "data-index": option.index,
    "data-value": escape(option.value),
    children: [renderOption && renderOption(props, option, {
      selected,
      highlighted
    }, className), !renderOption && /*#__PURE__*/(0,jsx_runtime.jsx)("button", Option_extends({
      type: "button",
      className: className
    }, props, {
      children: option.name
    }))]
  }, option.value);
}

Option.defaultProps = {
  renderOption: null
};
Option.propTypes =  false ? 0 : {};
/* harmony default export */ var Components_Option = (/*#__PURE__*/(0,react.memo)(Option));
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/lib/isSelected.js
function isSelected(itemValue, selectedValue) {
  if (!selectedValue) {
    return false;
  }

  return Array.isArray(selectedValue) // eslint-disable-next-line eqeqeq
  ? selectedValue.findIndex(item => item.value == itemValue.value) >= 0 // eslint-disable-next-line eqeqeq
  : selectedValue.value == itemValue.value;
}
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/Components/OptionsList.js








function OptionsList(_ref) {
  let {
    options,
    optionProps,
    snapshot,
    renderOption,
    renderGroupHeader,
    cls
  } = _ref;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    className: cls('options'),
    children: options.map(o => {
      if (o.type === 'group') {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          role: "none",
          className: cls('row'),
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: cls('group'),
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: cls('group-header'),
              children: renderGroupHeader ? renderGroupHeader(o.name) : o.name
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              className: cls('options'),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(OptionsList, {
                optionProps: optionProps,
                snapshot: snapshot,
                options: o.items,
                renderOption: renderOption,
                renderGroupHeader: renderGroupHeader,
                cls: cls
              })
            })]
          })
        }, o.groupId);
      }

      return /*#__PURE__*/(0,jsx_runtime.jsx)(Components_Option, {
        selected: isSelected(o, snapshot.option),
        highlighted: snapshot.highlighted === o.index,
        option: o,
        optionProps: optionProps,
        cls: cls,
        renderOption: renderOption
      }, o.value);
    })
  });
}

OptionsList.defaultProps = {
  renderGroupHeader: null,
  renderOption: null
};
OptionsList.propTypes =  false ? 0 : {};
/* harmony default export */ var Components_OptionsList = (/*#__PURE__*/(0,react.memo)(OptionsList));
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/Components/Options.js






function Options(_ref) {
  let {
    options,
    optionProps,
    snapshot,
    cls,
    renderGroupHeader,
    renderOption,
    emptyMessage
  } = _ref;
  const selectRef = (0,react.useRef)(null);
  const {
    value,
    highlighted
  } = snapshot;
  const renderEmptyMessage = (0,react.useCallback)(() => {
    if (emptyMessage === null) {
      return null;
    }

    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      className: cls('not-found'),
      children: typeof emptyMessage === 'function' ? emptyMessage() : emptyMessage
    });
  }, [emptyMessage, cls]);
  (0,react.useEffect)(() => {
    const {
      current
    } = selectRef;

    if (!current || highlighted < 0 && value === null) {
      return;
    }

    const val = Array.isArray(value) ? value[0] : value;
    const query = highlighted > -1 ? `[data-index="${highlighted}"]` : `[data-value="${escape(val)}"]`;
    const selected = current.querySelector(query);

    if (selected) {
      const rect = current.getBoundingClientRect();
      const selectedRect = selected.getBoundingClientRect();
      current.scrollTop = selected.offsetTop - rect.height / 2 + selectedRect.height / 2;
    }
  }, [value, highlighted, selectRef]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    (0,jsx_runtime.jsx)("div", {
      className: cls('select'),
      ref: selectRef,
      onMouseDown: e => e.preventDefault(),
      children: options.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(Components_OptionsList, {
        optionProps: optionProps,
        snapshot: snapshot,
        options: options,
        renderOption: renderOption,
        renderGroupHeader: renderGroupHeader,
        cls: cls
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
        className: cls('options'),
        children: renderEmptyMessage()
      })
    })
  );
}

Options.defaultProps = {
  renderOption: null,
  renderGroupHeader: null,
  emptyMessage: null
};
Options.propTypes =  false ? 0 : {};
/* harmony default export */ var Components_Options = (/*#__PURE__*/(0,react.memo)(Options));
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/useClassName.js

function useClassName(className) {
  return (0,react.useCallback)(key => {
    if (typeof className === 'function') {
      return className(key);
    }

    if (key.indexOf('container') === 0) {
      return key.replace('container', className);
    }

    if (key.indexOf('is-') === 0 || key.indexOf('has-') === 0) {
      return key;
    }

    return `${className.split(' ')[0]}__${key}`;
  }, [className]);
}
;// CONCATENATED MODULE: ./node_modules/react-select-search/dist/esm/SelectSearch.js
function SelectSearch_extends() { SelectSearch_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return SelectSearch_extends.apply(this, arguments); }










const SelectSearch = /*#__PURE__*/(0,react.forwardRef)((_ref, ref) => {
  let {
    value: defaultValue,
    disabled,
    placeholder,
    multiple,
    search,
    autoFocus,
    autoComplete,
    options: defaultOptions,
    id,
    onChange,
    onFocus,
    onBlur,
    printOptions,
    closeOnSelect,
    className,
    renderValue,
    renderOption,
    renderGroupHeader,
    getOptions,
    filterOptions,
    debounce,
    emptyMessage
  } = _ref;
  const cls = useClassName(className);
  const [snapshot, valueProps, optionProps] = useSelect({
    options: defaultOptions,
    value: defaultValue === null && (placeholder || multiple) ? '' : defaultValue,
    multiple,
    disabled,
    search,
    onChange,
    onFocus,
    onBlur,
    closeOnSelect: closeOnSelect && (!multiple || ['on-focus', 'always'].includes(printOptions)),
    getOptions,
    filterOptions,
    debounce
  });
  const wrapperClass = classes({
    [cls('container')]: true,
    [cls('is-disabled')]: disabled,
    [cls('is-loading')]: snapshot.fetching,
    [cls('has-focus')]: snapshot.focus
  });
  let shouldRenderOptions;

  switch (printOptions) {
    case 'never':
      shouldRenderOptions = false;
      break;

    case 'always':
      shouldRenderOptions = true;
      break;

    case 'on-focus':
      shouldRenderOptions = snapshot.focus;
      break;

    default:
      shouldRenderOptions = !disabled && (snapshot.focus || multiple);
      break;
  }

  const shouldRenderValue = !multiple || placeholder || search;

  const props = SelectSearch_extends({}, valueProps, {
    placeholder,
    autoFocus,
    autoComplete,
    value: snapshot.focus && search ? snapshot.search : snapshot.displayValue
  });

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    className: wrapperClass,
    id: id,
    children: [shouldRenderValue && /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: cls('value'),
      children: [renderValue && renderValue(props, snapshot, cls('input')), !renderValue && /*#__PURE__*/(0,jsx_runtime.jsx)("input", SelectSearch_extends({}, props, {
        className: cls('input')
      }))]
    }), shouldRenderOptions && /*#__PURE__*/(0,jsx_runtime.jsx)(Components_Options, {
      options: snapshot.options,
      optionProps: optionProps,
      snapshot: snapshot,
      cls: cls,
      emptyMessage: emptyMessage,
      renderOption: renderOption,
      renderGroupHeader: renderGroupHeader
    })]
  });
});
SelectSearch.defaultProps = {
  // Data
  getOptions: null,
  filterOptions: null,
  value: null,
  // Interaction
  multiple: false,
  search: false,
  disabled: false,
  printOptions: 'auto',
  closeOnSelect: true,
  debounce: 0,
  // Attributes
  placeholder: null,
  id: null,
  autoFocus: false,
  autoComplete: 'on',
  // Design
  className: 'select-search',
  // Renderers
  renderOption: undefined,
  renderGroupHeader: undefined,
  renderValue: undefined,
  emptyMessage: null,
  // Events
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {}
};
SelectSearch.propTypes =  false ? 0 : {};
/* harmony default export */ var esm_SelectSearch = (/*#__PURE__*/(0,react.memo)(SelectSearch));
// EXTERNAL MODULE: ./node_modules/react-select-search/style.css
var style = __webpack_require__(9914);
;// CONCATENATED MODULE: ./pages/index.js




















var __N_SSG = true;
function Home(param) {
    var titleData = param.titleData, productData = param.productData, dataOrmas = param.dataOrmas, dataPartner = param.dataPartner, contactName = param.contactName, contactNameSpbu = param.contactNameSpbu, bannerDataPc = param.bannerDataPc, bannerDataMobile = param.bannerDataMobile, contactFirst = param.contactFirst;
    var searchInput = (0,react.useRef)();
    var ref = (0,react.useState)(0), selectContact = ref[0], setselectContact = ref[1];
    var ref1 = (0,react.useState)(contactName[selectContact]), selectContactFull = ref1[0], setselectContactFull = ref1[1];
    var ref2 = (0,react.useState)(0), Index = ref2[0], setIndex = ref2[1];
    var ref3 = (0,react.useState)("depo"), tipeTampilContact = ref3[0], settipeTampilContact = ref3[1];
    var options;
    if (tipeTampilContact == "depo") {
        var contactDepo = [];
        contactName.map(function(con, index) {
            return contactDepo.push({
                name: con.name,
                value: index
            });
        });
        options = [
            {
                type: "group",
                name: "DEPO",
                items: _toConsumableArray(contactDepo)
            }
        ];
    } else if (tipeTampilContact == "spbu") {
        var contactSpbu = [];
        contactNameSpbu.map(function(con, index) {
            return contactSpbu.push({
                name: con.name,
                value: index
            });
        });
        options = [
            {
                type: "group",
                name: "SPBU",
                items: _toConsumableArray(contactSpbu)
            }
        ];
    }
    var handleFilter = function(items) {
        return function(searchValue) {
            if (searchValue.length === 0) {
                return options;
            }
            var updatedItems = items.map(function(list) {
                var newItems = list.items.filter(function(item) {
                    return item.name.toLowerCase().includes(searchValue.toLowerCase());
                });
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, list), {
                    items: newItems
                });
            });
            return updatedItems;
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        titlePage: "Home",
        titleData: titleData,
        dataOrmas: dataOrmas,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Carousel/* default */.Z, {
                bannerDataPc: bannerDataPc
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CarouselMobile/* default */.Z, {
                bannerDataMobile: bannerDataMobile
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                id: "content",
                className: "pt-5 bg-white keAtas",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-md-6 pe-5 text-black",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            children: titleData.judulSumber
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                titleData.deskripsiSumber,
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/#otherNav",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        className: "btn btn-primary d-block mt-5",
                                                        children: "PRODUK KAMI"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-6 mb-3",
                                    style: {
                                        padding: 0
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: titleData.imageSumber,
                                        className: "img-fluid shadow",
                                        width: 600,
                                        height: 600,
                                        quality: "100"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 1440 320",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#2780E3",
                            fillOpacity: "1",
                            d: "M0,0L48,21.3C96,43,192,85,288,128C384,171,480,213,576,197.3C672,181,768,107,864,106.7C960,107,1056,181,1152,208C1248,235,1344,213,1392,202.7L1440,192L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                id: "otherNav",
                className: "bg-primary overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row px-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-12 container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-white text-center",
                                    children: "Air Pegunungan Yang Membawa Kesegaran Alami..."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCarousel/* default */.Z, {
                                    productData: productData
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 1440 320",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#fff",
                            fillOpacity: "1",
                            d: "M0,224L40,218.7C80,213,160,203,240,186.7C320,171,400,149,480,128C560,107,640,85,720,101.3C800,117,880,171,960,197.3C1040,224,1120,224,1200,229.3C1280,235,1360,245,1400,250.7L1440,256L1440,320L1400,320C1360,320,1280,320,1200,320C1120,320,1040,320,960,320C880,320,800,320,720,320C640,320,560,320,480,320C400,320,320,320,240,320C160,320,80,320,40,320L0,320Z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                id: "partner",
                className: "bg-white overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SlickPartner/* default */.Z, {
                        dataPartner: dataPartner
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 1440 320",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            fill: "#ffff00",
                            fillOpacity: "1",
                            d: "M0,288L48,272C96,256,192,224,288,197.3C384,171,480,149,576,165.3C672,181,768,235,864,250.7C960,267,1056,245,1152,250.7C1248,256,1344,288,1392,304L1440,320L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                id: "contact",
                className: "bg-kuning pb-5 px-3",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-center text-primary fs-1 mb-5",
                            children: "Hubungi Kami (DEPO/SPBU)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: tipeTampilContact == "depo" ? "topnavActive badgebadge bg-kuning  me-3 d-inline col-2 text-white" : "topnav badgebadge bg-kuning  me-3 d-inline col-2 text-white",
                            onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            settipeTampilContact("depo");
                                            setselectContact(0);
                                            setselectContactFull(contactName[selectContact]);
                                        case 3:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            })),
                            children: "Depo AMDK"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: tipeTampilContact == "spbu" ? "topnavActive badgebadge bg-kuning  me-3 d-inline col-2 text-white" : "topnav badgebadge bg-kuning  me-3 d-inline col-2 text-white",
                            onClick: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            settipeTampilContact("spbu");
                                            setselectContact(0);
                                            setselectContactFull(contactNameSpbu[selectContact]);
                                        case 3:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            })),
                            children: "Agen AMDK (SPBU)"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "kontakContainer mb-3 shadow rounded p-5 text-black",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                    htmlFor: "formFile",
                                    className: "form-label",
                                    children: [
                                        "Sesuaikan ",
                                        tipeTampilContact,
                                        " dengan daerah terdekat anda "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_SelectSearch, {
                                    options: options,
                                    ref: searchInput,
                                    filterOptions: handleFilter,
                                    value: Index,
                                    name: "DEPO",
                                    placeholder: "Pilih Depo Dengan kota terdekat anda",
                                    search: true,
                                    onChange: function(e) {
                                        if (tipeTampilContact == "depo") {
                                            setselectContact(e);
                                            setselectContactFull(contactName[e]);
                                            setIndex(e);
                                        } else {
                                            setselectContact(e);
                                            setselectContactFull(contactNameSpbu[e]);
                                            setIndex(e);
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "mt-3",
                                    children: "Alamat Lengkap"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        children: selectContactFull.alamat
                                    })
                                }),
                                selectContactFull.linkMap && /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                    src: selectContactFull.linkMap,
                                    style: {
                                        width: "100%",
                                        height: "450px"
                                    },
                                    allowFullScreen: "",
                                    loading: "lazy",
                                    referrerPolicy: "no-referrer-when-downgrade"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row justify-content-center",
                            children: [
                                selectContactFull.wa && /*#__PURE__*/ (0,jsx_runtime.jsx)(little_Medsos, {
                                    linkMedsos: "https://api.whatsapp.com/send?phone=".concat(selectContactFull.wa, "&text=").concat(selectContactFull.pesanWa),
                                    fontMedsos: "bi-whatsapp",
                                    colorMedsos: "#075e54",
                                    contentMedsos: selectContactFull.wa
                                }),
                                selectContactFull.ig && /*#__PURE__*/ (0,jsx_runtime.jsx)(little_Medsos, {
                                    linkMedsos: "https://www.instagram.com/".concat(selectContactFull.ig, "/"),
                                    fontMedsos: "bi-instagram",
                                    colorMedsos: "#dd2a7b",
                                    contentMedsos: selectContactFull.ig
                                }),
                                selectContactFull.fb && /*#__PURE__*/ (0,jsx_runtime.jsx)(little_Medsos, {
                                    linkMedsos: "https://www.facebook.com/AirAlmasoem",
                                    fontMedsos: "bi-facebook",
                                    colorMedsos: "#395693",
                                    contentMedsos: selectContactFull.fb
                                }),
                                selectContactFull.email && /*#__PURE__*/ (0,jsx_runtime.jsx)(little_Medsos, {
                                    linkMedsos: "mailto:".concat(selectContactFull.email),
                                    fontMedsos: "bi-envelope",
                                    colorMedsos: "#bb001b",
                                    contentMedsos: selectContactFull.email
                                }),
                                selectContactFull.tiktok && /*#__PURE__*/ (0,jsx_runtime.jsx)(little_Medsos, {
                                    linkMedsos: "https://www.tiktok.com/".concat(selectContactFull.tiktok),
                                    fontMedsos: "bi-tiktok",
                                    colorMedsos: "#ff0050",
                                    contentMedsos: selectContactFull.tiktok
                                }),
                                selectContactFull.twitter && /*#__PURE__*/ (0,jsx_runtime.jsx)(little_Medsos, {
                                    linkMedsos: "https://twitter.com/".concat(selectContactFull.twitter),
                                    fontMedsos: "bi-twitter",
                                    colorMedsos: "#657786",
                                    contentMedsos: selectContactFull.twitter
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row justify-content-center border-top pt-2 mt-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "text-center text-primary",
                                    children: "Atau Pesan di"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-lg-4 col-md-5 col-sm-6 shadow bg-white p-3 rounded mx-1 mb-2 medsos text-black",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "text-center ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/shopee.png",
                                                alt: "",
                                                width: 100
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-center fs-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                href: "https://shopee.co.id/".concat(contactFirst.shopee),
                                                rel: "noopener noreferrer",
                                                children: contactFirst.shopee
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "col-lg-4 col-md-5 col-sm-6 shadow bg-white p-3 rounded mx-1 mb-2 medsos text-black",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "text-center ",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/tokped.png",
                                                alt: "",
                                                width: 100
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-center fs-6",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                target: "_blank",
                                                href: "https://www.tokopedia.com/".concat(contactFirst.tokopedia),
                                                rel: "noopener noreferrer",
                                                children: contactFirst.tokopedia
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 9914:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 7568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,488,698,640,774,888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);